import TooltipHint from './TooltipHint';

export default TooltipHint;
